import { Paginated } from "src/@types/paginated";
import { Tags } from "@/enum/tags";
import { apiSlice } from "../../../http";
import { IQueryParams, IQueryRules } from "@/@types/query";

export const QueryInformations = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getQueryRules: builder.query<Paginated<IQueryRules>, IQueryParams>({
      query: ({ meta, orderBy }) => {
        const params = new URLSearchParams({
          orderBy,
          page: meta.page.toString(),
          perPage: "1",
        });

        return {
          url: `/query-updates/rules?${params.toString()}`,
          method: "GET",
        };
      },
      providesTags: [Tags.QUERY_RULES],
    }),
    updateQueryRules: builder.mutation<
      void,
      { max_query: number; auto_approval: number }
    >({
      query: ({ max_query, auto_approval }) => ({
        url: `/query-updates/rules`,
        method: "PUT",
        body: { max_query, auto_approval },
      }),
      invalidatesTags: [Tags.QUERY_RULES],
    }),
    getRulesLogs: builder.query<Paginated<any>, IQueryParams>({
      query: ({ search, meta, orderBy, perPage }) => {
        const params = new URLSearchParams({
          search,
          orderBy,
          page: meta.page.toString(),
          perPage: perPage.toString(),
        });

        return {
          url: `/query-updates/rules-logs?${params.toString()}`,
          method: "GET",
        };
      },
      providesTags: [Tags.QUERY_RULES],
    }),
  }),
  overrideExisting: true,
});

export const {
  useGetQueryRulesQuery,
  useUpdateQueryRulesMutation,
  useGetRulesLogsQuery,
} = QueryInformations;
